import { css, jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { Fragment } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';
import { Img } from '../../display/Img/Img.es.js';
import { DefaultCompanies, AsanaIconMobile, AsanaIcon, DropboxIconMobile, DropboxIcon, MetaIconMobile, MetaIcon, ShopifyIconMobile, ShopifyIcon, SlackIconMobile, SlackIcon } from './logoIcons.es.js';

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const sanitizeClassName = (size) => {
  return `${size}`.replace(/[^a-z0-9]/gi, "-");
};
const Styles = labelStyles("LogoBar", {
  root: css`
    display: grid;
    justify-content: center;
    justify-items: center;
    grid-gap: 30px;
  `,
  title: css`
    ${Typography.smallPrint1};
    color: ${Colors.neutral700};
    justify-self: center;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.paragraph3}
    }
  `,
  logosContainer: css`
    display: grid;
    justify-content: center;
    grid-auto-flow: column;
    grid-gap: 40px;

    @media screen and (min-width: ${breakpoints.desktop}px) {
      grid-gap: 80px;
    }
  `,
  logoContainer: css`
    align-self: center;
    display: flex;
    justify-self: center;
  `,
  desktopLogoContainer: css`
    display: none;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: block;
    }
  `,
  mobileLogoContainer: css`
    display: block;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: none;
    }
  `,
  defaultLogo: (size) => [
    {
      "> svg": {
        height: "inherit",
        width: "inherit"
      }
    },
    size && withModifier(sanitizeClassName(`${size}x${size}`), {
      height: size,
      width: size
    })
  ]
});
const DefaultLogo = (props) => {
  return jsx("span", { css: Styles.defaultLogo(props.size), className: "logobar-defaultLogo", dangerouslySetInnerHTML: { __html: props.svg } });
};
const DefaultLogoIcons = {
  Asana: {
    mobile: AsanaIconMobile,
    desktop: AsanaIcon
  },
  Dropbox: {
    mobile: DropboxIconMobile,
    desktop: DropboxIcon
  },
  Meta: {
    mobile: MetaIconMobile,
    desktop: MetaIcon
  },
  Shopify: {
    mobile: ShopifyIconMobile,
    desktop: ShopifyIcon
  },
  Slack: {
    mobile: SlackIconMobile,
    desktop: SlackIcon
  }
};
const LogoBar = (_props) => {
  const { title, items, size, className } = _props;
  return jsx(
    "div",
    { css: Styles.root, className, "data-zds": true },
    jsx(
      HeadingLevel,
      null,
      jsx(
        Heading,
        null,
        jsx("div", { css: Styles.title, className: "logobar-title", "data-zds": true }, title)
      )
    ),
    jsx("ul", { css: Styles.logosContainer, className: "logobar-logosContainer", "data-zds": true }, items && items.length > 0 ? items.map(({ logoUrl, companyName }, i) => jsx(
      "li",
      { css: Styles.logoContainer, key: i + logoUrl, "data-zds": true },
      jsx(Img, { alt: companyName, borderRadius: 0, src: logoUrl, height: size, width: size })
    )) : DefaultCompanies.map((company) => jsx(
      Fragment,
      { key: company },
      jsx(
        "li",
        { css: [Styles.logoContainer, Styles.desktopLogoContainer], "data-zds": true },
        jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].desktop, { size }))
      ),
      jsx(
        "li",
        { css: [Styles.logoContainer, Styles.mobileLogoContainer], "data-zds": true },
        jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].mobile, { size }))
      )
    )))
  );
};

export { LogoBar };
//# sourceMappingURL=LogoBar.es.js.map
